<template>
  <!-- 专著发布页 -->
  <div class="form-content-container">
    <Form
      class="form-container"
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      label-position="left"
    >
      <FormItem
        ref="FormItemTitle"
        class="form-item"
        prop="title"
        :rules="[
          { required: true, message: '标题不能为空', trigger: 'change | blur' },
          { validator: validatetitle, trigger: 'change | blur' },
        ]"
      >
        <div class="title titleRichEditor">
          <!-- <Input
            class="titleInput"
            v-model="formValidate.title"
            :autosize="true"
            type="textarea"
            placeholder="请输入标题(5-50字)"
          /> -->
          <title-summary-editor
            v-if="titleFocus"
            bodyClass="chineseTitle"
            :id="'chineseTitle'"
            v-model.trim="formValidate.title"
            :initWithBold="true"
            initFontSize="36px"
            :minHeight="62"
            :placeholder="titlePlaceHolder"
            @changeValue="getTitle"
          ></title-summary-editor>
        </div>
        <div class="number">
          <span :class="wordCount > 50 ? 'fontColor' : ''">{{
            wordCount
          }}</span>
          / 50
        </div>
      </FormItem>
      <FormItem class="form-item" label="封面" prop="cover">
        <PictureUpload
          @handleUpload="handleUpload"
          :cover="formValidate.cover"
        ></PictureUpload>
      </FormItem>
      <OtherAuthor
        @autherInfo1="handleAuther1"
        :formValidate="formValidate"
      ></OtherAuthor>
      <FormItem class="form-item" label="内容简介" prop="artSummary">
        <Input
          type="textarea"
          :rows="5"
          placeholder="请输入内容简介"
          v-model.trim="formValidate.artSummary"
        />
      </FormItem>
      <FormItem class="form-item" label="出版单位" prop="press">
        <Input v-model.trim="formValidate.press" placeholder="请输入出版社" />
      </FormItem>
      <FormItem class="form-item" label="出版时间" prop="publishTime">
        <DatePicker
          type="month"
          placeholder="请输入出版时间"
          style="width: 200px"
          @on-change="changeTime"
          :options="endStartStr"
          :value="formValidate.publishTime"
        ></DatePicker>
      </FormItem>
      <FormItem class="form-item" label="ISBN" prop="isbn">
        <Input v-model.trim="formValidate.isbn" placeholder="请输入ISBN" />
      </FormItem>
      <FormItem class="form-item" label="版次" prop="edition">
        <Input v-model.trim="formValidate.edition" placeholder="请输入版次" />
      </FormItem>
      <FormItem class="form-item" label="页数" prop="pageNumber">
        <Input
          v-model.trim="formValidate.pageNumber"
          type="number"
          placeholder="请输入页数"
        />
      </FormItem>
      <FormItem class="form-item" label="字数" prop="monographLenght">
        <Input
          v-model.trim="formValidate.monographLenght"
          placeholder="请输入字数"
        />
      </FormItem>
      <FormItem class="form-item" label="分类号" prop="classifyNumber">
        <Input
          v-model.trim="formValidate.classifyNumber"
          placeholder="请输入分类号"
        />
      </FormItem>
      <FormItem
        class="form-item"
        label="目录"
        prop="catalogue"
        ref="FormItemCatalogue"
      >
        <Editor
          :id="'editor'"
          v-model="formValidate.catalogue"
          :placeholder="'请输入目录'"
        />
      </FormItem>
      <FormItem class="form-item" label="附件">
        <FileUplode
          :fileName="formValidate.accessoryName"
          @isUpload="isUpload"
          @handlefileUpload="handlefileUpload"
        />
      </FormItem>
      <!-- <FormItem class="form-item" label="外部链接" prop="externalUrl">
        <Input
          v-model.trim="formValidate.externalUrl"
          placeholder="请输入外部链接便于平台审核"
        />
      </FormItem> -->
      <FormItem class="form-item" label="商品链接" prop="payUrl">
        <Input
          v-model.trim="formValidate.payUrl"
          placeholder="请输入商品链接"
        />
      </FormItem>
      <FormItem class="form-item columnItem" label="发布栏目">
        <!-- <Checkbox v-model="formValidate.synchronizedStatus"></Checkbox>
        <span>{{ columnNum }}</span> -->
        <Tree
          :data="treeList"
          show-checkbox
          @on-check-change="changeCheck"
        ></Tree>
      </FormItem>
      <div class="submit-container">
        <Button @click="preview" :disabled="isShow" v-throttleClick="2000"
          >预览</Button
        >
        <Button
          :disabled="isUploadState || canClick"
          @click="handleSubmit(formValidate, 1)"
          v-throttleClick="2000"
          >保存</Button
        >
        <Button
          :disabled="isUploadState || canClick"
          @click="handleSubmit(formValidate, 0)"
          v-throttleClick="2000"
          >发布</Button
        >
      </div>
    </Form>
    <AuthenticationModel
      v-if="isFlag"
      @handleClose="isFlag = false"
    ></AuthenticationModel>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PictureUpload from "../../components/PictureUpload.vue";
import FileUplode from "../../components/fileUplode.vue";
import AuthenticationModel from "../../components/AuthenticationModel.vue";
import OtherAuthor from "../../components/OtherAuthor.vue";
import Editor from "../../components/editor";
import ruleUtils from "@/utils/ruleValidate.js";
import TitleSummaryEditor from "@/views/PCView/user/components/TitleSummaryEditor";
export default {
  components: {
    PictureUpload,
    AuthenticationModel,
    OtherAuthor,
    FileUplode,
    TitleSummaryEditor,
    Editor,
  },
  created() {
    // 认证
    if (this.userInfo.user.customerType === 1) {
      this.isFlag = true;
    }
    this.projectAndColumnListByType({
      type: 4,
    });
    if (this.$route.query.id) {
      this.getEcho(this.formValidate);
      this.isShow = false;
    } else {
      setTimeout(() => {
        this.getTrees();
      }, 1000);
    }
  },
  mounted() {
    this.titleFocus = true;
  },
  data() {
    return {
      titleFocus: false,
      isShow: true,
      canClick: false,
      wordCount: 0,
      titlePlaceHolder: "请输入标题(0~50)字",
      isUploadState: false,
      disabledStr: "",
      isFlag: false,
      tempArr: [],
      treeList: [], //发布栏目
      ismodify: 1,
      formValidate: {
        title: "",
        cover: "",
        artSummary: "",
        press: "",
        publishTime: "",
        isbn: "",
        edition: "",
        pageNumber: "",
        monographLenght: "",
        classifyNumber: "",
        catalogue: "",
        externalUrl: "",
        payUrl: "",
        filePath: "",
        accessoryName: "",
        // monographAuthor: "",
        interest: [],
        synchronizedStatus: false,
        articleAuthorList: [
          {
            authorId: "",
            authorName: "",
            authorUnit: "",
            authorUnitId: "",
            authorType: 0,
          },
        ],
        translator: [''],
      },
      ruleValidate: ruleUtils,
      previewData: {
        data: {
          articleId: this.$route.query.id ? this.$route.query.id : "",
          articleType: 2,
        },
      },
    };
  },
  computed: {
    ...mapState(["token", "userInfo"]),
    columnNum() {
      let str = "";
      if (sessionStorage.getItem("isSon") === "false") {
        if (this.userInfo.user.customerType === 4) {
          str = "百科号";
        } else if (this.userInfo.user.customerType === 5) {
          str = "机构号";
        } else if (
          this.userInfo.user.customerType === 1 ||
          this.userInfo.user.customerType === 2
        ) {
          str = "百家号";
        }
      } else {
        if (this.userInfo.user.subType === 1) {
          str = "百科号";
        } else if (this.userInfo.user.subType === 2) {
          str = "机构号";
        }
      }
      return str;
    },
    endStartStr() {
      return {
        disabledDate: (data) => {
          let d = new Date(data).valueOf();
          return data && new Date().valueOf() < d;
        },
      };
    },
  },
  watch: {
    "formValidate.catalogue"() {
      this.$refs.FormItemCatalogue.$emit("on-form-change"); // 对非View组件触发表单校验change方法
    },
    "formValidate.title": {
      handler() {
        this.$refs.FormItemTitle.$emit("on-form-change"); // 对非View组件触发表单校验change方法
      },
      deep: true,
      // immediate: true,
    },
  },
  methods: {
    // 预览
    async preview() {
      const resp = await this.$apis.userServe.setPreview({
        ...this.previewData.data,
      });
      let URL = this.$router.resolve({
        path: "/bookpreview",
        query: {
          articleId: resp.data,
        },
      });
      window.open(URL.href, "_blank");
    },
    validatetitle(rule, value, callback) {
      var reg = new RegExp("<[^<>]+>", "g");
      var s = value.replace(reg, "");
      var reg2 = /\&[0-9a-z]+;/g;
      if (s.match(reg2) != null && s.match(reg2).length != 0) {
        s = s.replace(reg2, " ");
      }
      if (s.length < 5 || s.length > 50) {
        return callback(new Error("标题限制5到50个字数"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    },
    getTitle(params) {
      /* params接收富文本对象，以JSON字符串方式传递，需解析为对象；
      解析后格式如{id: "englishTitle",value:{default: ""}} */
      params = JSON.parse(params);
      // 获取富文本输入框ID，用于区分
      var editorId = params.id;

      // params.value获取富文本输入框的值，有两种可能的值，默认为对象类型 value:{default: ""}；一旦有值，则变为字符串类型，如value: '<p style="line-height: 1.5;">&nbsp;'
      let originalText = params.value; // 获取富文本输入框原始值
      if (typeof originalText == "object") originalText = "";

      // 定义正则表达式reg 过滤标签（无法正常保留<>,如遇<某某决议>这种，还需修改正则）
      var reg = new RegExp("<[^<>]+>", "g");
      // 过滤后的字符串内容，用于统计字数
      let countText = originalText.replace(reg, "");

      // 现将特殊字符$nbsp;替换成空格然后将其他特殊字符匹配成1来便于计数
      var reg2 = /\&[0-9a-z]+;/g;
      countText = countText.replace(/&nbsp;/gi, "");
      if (countText.match(reg2) != null && countText.match(reg2).length != 0) {
        countText = countText.replace(reg2, "1");
      }
      // 将原值中的额$nbsp;替换为普通空格(html中的空格)
      originalText = originalText.replace(/&nbsp;/gi, "");

      // 不为空时，保留sub,sup标签，过滤其他标签
      originalText = originalText.replace(/(?!<(\/?sub|\/?sup).*?>)<.*?>/g, "");
      originalText = originalText.trim();
      // 去掉头尾空格以计数
      countText = countText.trim();

      if (editorId == "chineseTitle") {
        this.formValidate.title = originalText;
        countText = this.filterSubSup(countText);
        this.wordCount = countText.length;
      }
      this.$refs.FormItemTitle.$emit("on-form-change"); // 对非View组件触发表单校验change方法
    },
    // 过滤字符串中的sub/sup标签，返回过滤后的字符串。以计字数
    filterSubSup(s) {
      if (s.indexOf("<sub>") != -1 || s.indexOf("<sup>") != -1) {
        s = s.replace(/<sub>/gi, "");
        s = s.replace(/<\/sub>/gi, "");
        s = s.replace(/<sup>/gi, "");
        s = s.replace(/<\/sub>/gi, "");
      }
      return s;
    },
    // 提交表单按钮
    async handleSubmit(formValidate, status) {
      this.canClick = true;
      // 认证
      if (this.userInfo.user.customerType === 1) {
        this.isFlag = true;
        return;
      }
      this.$refs.formValidate.validate(async (valid) => {
        if (valid) {
          if (this.tempArr.length === 0) {
            this.treeList.forEach((item) => {
              if (item.children && item.children.length > 0) {
                item.children.forEach((v) => {
                  if (v.checked) {
                    this.tempArr.push(v);
                  }
                });
              } else {
                if (item.checked) {
                  this.tempArr.push(item);
                }
              }
            });
          }
          // 发布栏目
          let arr = [];
          this.tempArr.forEach((item) => {
            if (!(item.children && item.children.length > 0)) {
              arr.push({
                projectId: item.menuIds || null,
                channelId1: item.id || null,
              });
            } else {
              return;
            }
          });
          formValidate.interest = [...arr];
          const { data } = await this.$apis.userServe.webSave({
            auditStatus: status === 1 ? 1 : this.ismodify === 2 ? 2 : 0, // this.ismodify === 2 已发布修改, status 1是保存 2是发布
            articleType: 2,
            articleId:
              this.$route.query.id || this.previewData.data.articleId || null,
            cover: formValidate.cover,
            monographName: formValidate.title,
            artSummary: formValidate.artSummary,
            press: formValidate.press,
            publishTime: formValidate.publishTime + "-01",
            isbn: formValidate.isbn,
            edition: formValidate.edition,
            pageNumber: formValidate.pageNumber,
            monographLenght: formValidate.monographLenght,
            classifyNumber: formValidate.classifyNumber,
            catalogue: formValidate.catalogue,
            externalUrl: formValidate.externalUrl,
            payUrl: formValidate.payUrl,
            filePath: formValidate.filePath,
            accessoryName: formValidate.accessoryName,
            articlePushList: formValidate.interest,
            articleAuthorList: formValidate.articleAuthorList, // 其他作者
            translator: formValidate.translator.filter(item => item !== ''),
            synchronizedStatus:
              formValidate.synchronizedStatus === true ? 1 : 0,
          });
          if (data.resultCode !== "200") {
            this.canClick = false;
            this.$Message.error(data.resultDesc);
            return;
          } else {
            this.$Message.success(status === 1 ? "保存成功" : "发布成功");
            this.previewData = data;
            this.isShow = false;
            this.canClick = false;
            if (status === 1) return;
            this.$router.push("/user/contentMrg");
            // this.clearField(); // 清空
          }
        } else {
          this.canClick = false;
          this.$Message.error("填写错误,请检查后重新提交");
        }
      });
    },
    // 回显
    async getEcho(f) {
      const resp = await this.$apis.userServe.getDetailsByUser({
        articleId: this.$route.query.id,
        articleType: 2,
      });
      const r = resp.data.data;
      this.ismodify = r.auditStatus;
      this.getTrees();
      // 发布栏目
      resp.data.articlePushList.forEach((itemL) => {
        this.treeList.forEach((itemT) => {
          if (
            itemT.children &&
            itemT.children.length > 0 &&
            itemL.projectId !== undefined
          ) {
            itemT.children.forEach((itemC) => {
              if (itemC.id == itemL.channelId1) {
                itemC["checked"] = true;
              }
            });
          } else {
            if (itemT.menuIds == itemL.projectId) {
              itemT["checked"] = true;
            }
          }
        });
      });
      // 其他作者
      f.articleAuthorList = r.articleAuthors.map((item) => {
        return {
          authorId: item.authorId,
          authorName: item.authorName,
          authorUnit: item.authorUnit,
          authorUnitId: item.authorUnitId ? item.authorUnitId : "null",
          authorType: item.authorType,
        };
      });
      f.cover = r.cover;
      f.title = r.monographName;
      f.artSummary = r.artSummary;
      f.press = r.press;
      f.publishTime = r.publishTime;
      f.isbn = r.isbn;
      f.edition = r.edition;
      f.pageNumber = r.pageNumber;
      f.monographLenght = r.monographLenght;
      f.classifyNumber = r.classifyNumber;
      f.catalogue = r.catalogue;
      f.externalUrl = r.externalUrl;
      f.payUrl = r.payUrl;
      f.filePath = 1;
      f.accessoryName = r.accessoryName;
      f.translator = r.translatorJson.length > 0 ? r.translatorJson : [''] ;
      // f.interest = resp.data.articlePushList;
      // f.monographAuthor = r.monographAuthor;
      f.synchronizedStatus = r.synchronizedStatus == 1 ? true : false;
    },
    handleAuther1(list) {
      this.formValidate.articleAuthorList = list;
    },
    changeTime(obj) {
      this.formValidate.publishTime = obj;
    },
    isUpload(state) {
      this.isUploadState = state;
    },
    handlefileUpload(url, name) {
      this.formValidate.filePath = url;
      this.formValidate.accessoryName = name;
    },
    getTrees() {
      this.treeList = this.treeList.map((item) => {
        return {
          title: item.projectName,
          expand: true,
          menuIds: item.projectId,
          checked: false,
          children:
            item.columns &&
            item.columns.map((v) => {
              return {
                title: v.columnName,
                menuIds: item.projectId,
                id: v.id,
                checked: false,
              };
            }),
        };
      });
    },
    handleUpload(url) {
      this.formValidate.cover = url; // 图片路径
    },
    changeCheck(item) {
      this.tempArr = item;
    },
    async projectAndColumnListByType(data) {
      const resp = await this.$apis.userServe.projectAndColumnListByType(data);
      this.treeList.push(resp.data[0]);
    },
    clearField() {
      // 清空
      this.formValidate.cover = "";
      this.formValidate.title = "";
      this.formValidate.artSummary = "";
      this.formValidate.press = "";
      this.formValidate.publishTime = "";
      this.formValidate.isbn = "";
      this.formValidate.edition = "";
      this.formValidate.pageNumber = "";
      this.formValidate.monographLenght = "";
      this.formValidate.classifyNumber = "";
      this.formValidate.catalogue = "";
      this.formValidate.externalUrl = "";
      this.formValidate.payUrl = "";
      this.formValidate.filePath = "";
      this.formValidate.accessoryName = "";
      // this.formValidate.monographAuthor = "";
      this.formValidate.synchronizedStatus = false;
      this.formValidate.articleAuthorList = [];
      this.formValidate.translator = [];
    },
  },
};
</script>

<style lang="scss" scoped>
#text-container ::v-deep table {
  th,
  td {
    width: 200px;
    height: 35px;
    vertical-align: top;
    word-break: break-all;
  }
}
::v-deep #text-container .placeholder {
  color: #999;
}
::v-deep #text-container .w-e-text-container {
  z-index: 1 !important;
}
::v-deep #text-container {
  width: 100%;
  min-height: 300px;
  border: none;
  outline: none;
  color: #515a6e;
}
::v-deep .ivu-tree ul li {
  margin: 0;
}
::v-deep .ivu-tree-children li {
  display: flex;
}
::v-deep .ivu-tree-children li .ivu-tree-arrow {
  display: none;
}
::v-deep .ivu-tree-children li .ivu-tree-children li {
  margin: 30px 40px 0 -60px;
}

::v-deep .ivu-tree-title:hover {
  background-color: #fff;
}
::v-deep .ivu-tree-title-selected,
.ivu-tree-title-selected:hover {
  background-color: #fff;
}
::v-deep .ivu-tree-children li .ivu-tree-title {
  width: 100px;
}
::v-deep .ivu-radio-group {
  white-space: nowrap;
}
.form-content-container {
  overflow: hidden;
  width: 1200px;
  margin: 38px auto 100px;
  background-color: #fff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
}
.ivu-input-wrapper ::v-deep input {
  border: none;
  background-color: #fff;
  height: 38px;
}
.ivu-input-wrapper ::v-deep input::-webkit-input-placeholder,
.ivu-input-wrapper ::v-deep textarea::-webkit-input-placeholder {
  color: #999;
}
.ivu-upload ::v-deep .ivu-upload-drag {
  border: none;
  display: flex;
  align-items: center;
}
::v-deep .ivu-upload {
  display: flex;
  align-items: center;
}
.ivu-input-wrapper ::v-deep textarea {
  border: none;
}
.fontColor {
  color: red !important;
}
.form-container {
  margin: 0 auto 100px;
  padding: 60px 100px 0;
  width: 1200px;
  min-height: 1228px;
  background-color: #fff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  .form-item {
    padding-bottom: 25px;
    width: 100%;
    color: #999;
    &::v-deep .ivu-form-item-label {
      min-width: 80px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    &::v-deep .ivu-form-item-content {
      display: flex;
    }
    &:not(:last-child) {
      border-bottom: 1px solid #dcdcdc;
    }
    .title {
      flex: 1;
      display: flex;
      align-items: flex-end;
      height: 100%;
      line-height: 38px;
      position: relative;
      .titleInput {
        flex: 1;
        margin-right: 10px;
      }
      ::v-deep .ivu-input-type-textarea {
        textarea {
          font-size: 36px;
          resize: none;
        }
      }
    }
    .columnItem {
      display: flex;
      &::v-deep .ivu-form-item-content {
        display: flex;
        align-items: flex-start;
        flex: 1;
      }
    }
    .left {
      border-right: 1px solid #dcdcdc;
      width: 355px;
    }
    .right {
      margin-left: 10px;
      width: 642px;
    }
    .year,
    .center,
    .stage {
      display: flex;
      align-items: center;
    }
    .year {
      width: 299px;
      border-right: 1px solid #dcdcdc;
    }
    .center {
      width: 323px;
      border-right: 1px solid #dcdcdc;
    }
    .stage {
      width: 374px;
    }
    .checkbox {
      width: 970px;
      display: flex;
      padding-left: 7px;
      label {
        margin-right: 20px;
      }
    }
    .upload {
      display: flex;
      flex: 1;
      padding-left: 7px;
      align-items: center;
      label {
        margin-right: 20px;
      }
    }
  }
  .title-item {
    align-items: end;
  }
}
.submit-container {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 80px;
  height: 70px;
  background-color: #fff;
  text-align: center;
  line-height: 70px;
  button {
    margin: 0 10px;
  }
}
</style>
